import { createContext, useContext } from 'react';

export const MISSING_CONTEXT = Symbol('missing context');

export const buildContext = <T>(
  contextName: string,
  defaultValue: T | typeof MISSING_CONTEXT = MISSING_CONTEXT,
) => {
  const Context = createContext<T | typeof MISSING_CONTEXT>(defaultValue);

  const useCustomContext = (): T => {
    const context = useContext(Context);
    if (context === MISSING_CONTEXT) {
      throw new Error(`${contextName} was not provided`);
    }
    return context;
  };

  return {
    Context,
    useContext: useCustomContext,
  };
};
